(function(){
  var IMAGE_LIST=[
    'https://cdn.shopify.com/s/files/1/0908/1248/1819/files/poster_wall_art_78e58511-2a77-4623-992c-41eed7a08041.png?v=1784294766',
    'https://cdn.shopify.com/s/files/1/0908/1248/1819/files/canvas_by_joffzart_618eb780-f9e7-4073-8ae4-e7c9eb6201f5.png?v=1784297651',
    'https://cdn.shopify.com/s/files/1/0908/1248/1819/files/oak_frame_new.png?v=1784294654',
    'https://cdn.shopify.com/s/files/1/0908/1248/1819/files/white_frame.png?v=1784294581',
    'https://cdn.shopify.com/s/files/1/0908/1248/1819/files/black_frame.png?v=1784294344'
  ];
  var KEYS=['poster','stretched canvas','oak frame','white frame','black frame'];
  var style=document.createElement('style');
  style.textContent='@media(max-width:749px){.joffz-size-guide-btn{width:72px!important;height:44px!important;margin-top:10px!important;border-width:1px!important}.joffz-size-guide-btn svg{width:50px!important;height:26px!important}}';
  document.head.appendChild(style);

  function variantFieldsets(root){
    return Array.prototype.slice.call((root||document).querySelectorAll('variant-selects fieldset, .product-form fieldset')).filter(function(f){return !!f.querySelector('select');});
  }
  function isSizeField(f,index,total){
    var s=f.querySelector('select');
    if(!s)return false;
    var text=Array.prototype.map.call(s.options,function(o){return o.textContent||'';}).join(' ').toLowerCase();
    return /cm|inch|zoll|pouce|pollic|pulg|inç|olcu|ölç|taille|größe|groesse|size|misura|tamaño|×|\d+\s*[xX]\s*\d+/.test(text)||(total>1&&index===1);
  }
  function finishFallback(f){
    if(!f||f.querySelector('.joffz-finish-grid'))return;
    var s=f.querySelector('select');
    if(!s||s.options.length<2||s.options.length>8)return;
    f.classList.add('joffz-finish-fieldset');
    var g=document.createElement('div');
    g.className='joffz-finish-grid';
    g.setAttribute('role','radiogroup');
    Array.prototype.forEach.call(s.options,function(o,i){
      var c=document.createElement('button');
      c.type='button';
      c.className='joffz-finish-card';
      c.dataset.value=o.value;
      c.dataset.key=KEYS[i]||('finish-'+i);
      c.disabled=o.disabled;
      c.setAttribute('role','radio');
      var label=(o.textContent||o.value||'').trim();
      c.innerHTML='<span class="joffz-finish-card__media"><img class="joffz-finish-card__image" src="'+(IMAGE_LIST[i]||IMAGE_LIST[0])+'" alt="" loading="lazy"></span><span class="joffz-finish-card__label"></span>';
      c.querySelector('.joffz-finish-card__label').textContent=label;
      c.querySelector('img').alt=label;
      c.addEventListener('click',function(){
        if(o.disabled)return;
        s.value=o.value;
        s.dispatchEvent(new Event('input',{bubbles:true}));
        s.dispatchEvent(new Event('change',{bubbles:true}));
        sync();
      });
      g.appendChild(c);
    });
    function sync(){
      Array.prototype.forEach.call(g.querySelectorAll('.joffz-finish-card'),function(c){
        var on=c.dataset.value===s.value;
        c.classList.toggle('is-selected',on);
        c.setAttribute('aria-checked',on?'true':'false');
      });
    }
    s.addEventListener('change',sync);
    f.appendChild(g);
    sync();
  }
  function sizeFallback(f){
    if(!f)return;
    f.classList.add('joffz-size-fieldset');
    if(f.querySelector('.joffz-size-guide-btn'))return;
    var b=document.createElement('button');
    b.type='button';
    b.className='joffz-size-guide-btn';
    b.setAttribute('aria-label','Size guide');
    b.innerHTML='<svg viewBox="0 0 120 62" aria-hidden="true"><path d="M12 16h96M12 16v31h96V16M23 16v12M35 16v18M47 16v12M59 16v18M71 16v12M83 16v18M95 16v12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>';
    b.addEventListener('click',function(){
      var o=document.getElementById('joffz-size-guide-overlay');
      if(o)o.classList.add('is-open');
    });
    f.appendChild(b);
  }
  function enhance(root){
    var fs=variantFieldsets(root);
    if(!fs.length)return;
    var sizeIndex=-1;
    fs.forEach(function(f,i){if(sizeIndex<0&&isSizeField(f,i,fs.length))sizeIndex=i;});
    if(sizeIndex<0&&fs.length>1)sizeIndex=1;
    var finishIndex=sizeIndex===0&&fs.length>1?1:0;
    finishFallback(fs[finishIndex]);
    sizeFallback(fs[sizeIndex]);
  }
  function start(){
    enhance(document);
    var t;
    new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){enhance(document);},100);}).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',function(e){setTimeout(function(){enhance(e.target);},100);});
  }
  var current=document.currentScript;
  var src=current&&current.src?current.src.replace('product-single.js','product-single-original.js'):'';
  if(src){
    var script=document.createElement('script');
    script.src=src;
    script.onload=function(){setTimeout(start,0);};
    document.head.appendChild(script);
  }else{
    start();
  }
})();